module.exports = __webpack_public_path__ + "static/11-6f9ef98bd38f3ffad8dabed1e524e966.jpg";